import { useEffect, useState } from 'react';
import EditSharpIcon from '@mui/icons-material/EditSharp';
import { formatSiteNameWithAddress, getUpDownKm } from './CustomerMainUtils';
import { openCustomerSiteDocuments } from '../../utils/customerTransactionPopup';
import { getCustomerSiteDocumentCounts } from '../../services/ReportServices';
import './CustomerSitesTable.css';

const SITE_DOCUMENT_TYPES = [
  { type: 'quotation', label: 'Quotation' },
  { type: 'sales_order', label: 'Sales Order' },
  { type: 'schedule', label: 'Schedules' },
  { type: 'design_mix', label: 'Design Mix' },
  { type: 'delivery_challan', label: 'Delivery Challan' },
  { type: 'invoice', label: 'Invoice' },
];

const EMPTY_COUNTS = {
  quotation: 0,
  sales_order: 0,
  schedule: 0,
  design_mix: 0,
  delivery_challan: 0,
  invoice: 0,
};

function CustomerSitesTable({
  siteData,
  onAdd,
  onDelete,
  onEdit,
  showSiteCount = false,
  cookies,
  customerId,
  customerName = '',
}) {
  const [countsBySite, setCountsBySite] = useState({});

  useEffect(() => {
    if (!customerId || !cookies?.myToken) {
      setCountsBySite({});
      return undefined;
    }
    let cancelled = false;
    getCustomerSiteDocumentCounts(cookies, customerId)
      .then((response) => {
        if (!cancelled) {
          setCountsBySite(response.counts || {});
        }
      })
      .catch(() => {
        if (!cancelled) {
          setCountsBySite({});
        }
      });
    return () => {
      cancelled = true;
    };
  }, [customerId, cookies, siteData.length]);

  const openDocuments = (site, transactionType) => {
    openCustomerSiteDocuments({
      cookies,
      transactionType,
      customerId,
      consigneeId: site.id,
      customerName,
      projectName: site.project_name || site.site_name || '',
    });
  };

  const countFor = (site, type) => {
    if (!site.id) {
      return 0;
    }
    const siteCounts = countsBySite[String(site.id)] || EMPTY_COUNTS;
    return Number(siteCounts[type] || 0);
  };

  return (
    <div className="customer-sites-block">
      {showSiteCount && (
        <div className="customer-sites-summary">
          <b>No. of Sites Associated with this Customer: {siteData.length}</b>
        </div>
      )}
      <div className="customer-sites-table-wrap">
        <table className="table customer-sites-table">
        <thead>
          <tr>
            <th>
              <button type="button" className="btn btn-success" onClick={onAdd}>+</button>
            </th>
            <th>Site Name &amp; Address</th>
            <th>Project Name</th>
            <th>Up &amp; Down KM</th>
            {SITE_DOCUMENT_TYPES.map((doc) => (
              <th key={doc.type}>{doc.label}</th>
            ))}
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {siteData.map((site, index) => (
            <tr key={site.id || index}>
              <td>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => onDelete(index)}
                >
                  x
                </button>
              </td>
              <td>{formatSiteNameWithAddress(site)}</td>
              <td>{site.project_name || ''}</td>
              <td className="text-center">{getUpDownKm(site)}</td>
              {SITE_DOCUMENT_TYPES.map((doc) => {
                const count = countFor(site, doc.type);
                return (
                  <td key={doc.type} className="text-center">
                    <button
                      type="button"
                      className={`customer-sites-doc-btn${count ? '' : ' is-zero'}`}
                      onClick={() => openDocuments(site, doc.type)}
                    >
                      {count}
                    </button>
                  </td>
                );
              })}
              <td className="text-center">
                <EditSharpIcon
                  onClick={() => onEdit(index)}
                  sx={{
                    cursor: 'pointer',
                    fontSize: '24px',
                    color: 'white',
                    backgroundColor: 'blue',
                    padding: '1px',
                    borderRadius: '4px',
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
        </table>
      </div>
    </div>
  );
}

export default CustomerSitesTable;
